import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef, Renderer2, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as jwt_decode from 'jwt-decode';
import { ThemingService } from '../../../../theming.service'
import { CommonService } from 'src/app/middleware/common/common.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { Subscription } from 'rxjs';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { ToastrService } from 'ngx-toastr';
import { SignalRHubService } from 'src/app/services/SignalRHubService.service';
import { environment } from 'src/environments/environment';
import { AIChatService } from '../services/aichat.service';
import { LoaderService } from '../../loader/loader.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  selectedLanguage: any;
  searchbar: boolean = false;
  input: EventEmitter<any>;
  show: boolean = true;
  darkTheme = new FormControl(false);
  themes: string[];
  currentTheme: string
  officeList: [];
  @Output() openChat = new EventEmitter<boolean>()
  showAddContact: boolean = false;
  Module: string;

  value: any;
  profileImagePath: any;
  userToken: any;
  decodedUserData: any;
  encryptedUserToken: any;
  folderList: any[] = [];
  permissionAsssign: any[] = [];
  folderListPermission: any[] = [];
  clickEventsubscription: Subscription;
  projectNameclickEventsubscription: Subscription;
  clickEventsubscriptionUser: Subscription;
  notificationSubscription: Subscription;
  modulename: string = "";
  showCreateTask: boolean = false;
  currentUser: any;
  projectName: any;
  databaseId: string;
  organizationId: string;
  responseHolder: any;
  type: any;
  projectNameExist: any;

  NotificationList: any = [] = [];
  UnreadNotification: any = 0;
  showLocalPanel: boolean = false;

  userManageResponseHolder: any;
  userDetails: any;
  ImagePathURL: string = '';
  FullName: string = "";
  menuModulesList: any[] = [];
  edashboard: string = "";

  OfficeIDList: any = [];
  myOfficeID: any;
  ShowChat: boolean = false;
  currentLink: string;
  htmlFormLinkActivated: boolean
  currentFormName: any;
  clickFormEventsubscription: Subscription;
  userDetailform: FormGroup;
  folderAccess: any;
  menuModules: any;
  loginToken: any;
  permissionsAssigned: any;
  databaseID: any;
  organizationID: any;
  toggleButtonClick: boolean = false;
  associatedAPIs: any;
  dialogRef: MatDialogRef<any, any>;
  saveDialogRef: MatDialogRef<any, any>;
  aiData: any = [];
  aiDataHistory: any = [];
  currentOffice:any;
  gotResult: any;
  officeLogo:string="";

  constructor(private formBuilder: FormBuilder, private signalRconnaction: SignalRHubService,
    private theming: ThemingService, private commonService: CommonService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private cdr: ChangeDetectorRef, private _dataSharingService: DataSharingService,
    private router: Router, private statusConstant: StatusConstant, private formService: FormsService,
    private toastr: ToastrService, private activatedRoute: ActivatedRoute, private renderer: Renderer2, private dialog: MatDialog,
    private saveDialog: MatDialog, private _aiChatService: AIChatService, private statusConst: StatusConstant, private loaderService: LoaderService,) {


    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.toggleButtonClick) {
        this.showOtherLinks = false;
      }
      this.toggleButtonClick = false;
    });

    this.userDetailform = this.formBuilder.group({
      selectedOffice: ['', Validators.nullValidator]
    });
    this.encryptedUserToken = sessionStorage.getItem("userToken");
    this.userToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.encryptedUserToken);
    this.decodedUserData = jwt_decode(this.userToken);
    this.getShortName(this.decodedUserData.Name);

    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    this.input = new EventEmitter();
    this.currentTheme = "light-theme"
    this.theming.theme.next(this.currentTheme);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });

    this.router.events.subscribe(value => {
      this.currentLink = this.router.url.toString()
      this.htmlFormLinkActivated = (this.currentLink == '/esignature/htmlform') ? true : false;
    });
  }

  preventCloseOnClick() {
    this.toggleButtonClick = true;
  }

  onOfficeddlStatusChange(e: any) {
    this.gotResult = false;
    let userOffices = JSON.parse(sessionStorage.getItem('officeList'));
    userOffices.forEach(oe => {
      if (oe.officeID == e.target.value) {
        this.myOfficeID = oe.officeID;
        oe.isMyoffice = true;
      } else {
        oe.isMyoffice = false;
      }
    });
    this.myOfficeID = e.target.value;

    this.officeList.forEach((office) => {
      this.currentOffice = this.checkIselectedOffice(office)

    if(this.currentOffice){
      this.gotResult = true;
      return
    }
   });   

    sessionStorage.setItem('officeList', JSON.stringify(userOffices));
    this._dataSharingService.sendFetchDashboardfavourite(true);
    this.validateToken(e.target.value);
    this.getOfficeDetail();
    this.getThirdPartyApplicationList();

  }

  getUserOffices() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.formService.getUserOffices(ReqModel).subscribe(response => {
      if (response) {
        response;
        if (response.status == this.statusConstant.statusSuccess) {
          this.officeList = response.data;
          this.userDetailform.get('selectedOffice').setValue(this.myOfficeID);
          let userOffices = JSON.parse(sessionStorage.getItem('officeList'));
          userOffices.forEach(oe => {
            if (oe.officeID == this.myOfficeID) {
              this.myOfficeID = oe.officeID;
              oe.isMyoffice = true;
            }
            else {
              oe.isMyoffice = false;
            }
          });
          this.officeList.forEach((office) => {
            this.currentOffice = this.checkIselectedOffice(office)
            if(this.currentOffice){
              this.gotResult = true;
              return
            }
          });
          sessionStorage.setItem('officeList', JSON.stringify(userOffices));
        }
        else {

        }
      }
    });
  }

  checkIselectedOffice(office){
    if(this.gotResult)
    return this.currentOffice
    const keyToCheck = 'officeID';
    if (keyToCheck in office &&  office.officeID == this.myOfficeID ) {
      return office.officeName
    } 
  }

  validateToken(officeID: any) {
    //this.enableConfirmButton=false;
    //this.tokenValidationReqVM.twoFactorCode = passcode;
    //Api call to validate token..
    //this.loaderService.show();
    //this.spinner=true;
    this.formService.validateToken({
      userID: this.currentUser.UID,
      officeID: Number(officeID),
      IsOfficeChanged: true,
      TwoFactorCode: "2345",
      UserName: "",
      AuthenticationType: ""
    }).subscribe(response => {
      if (response) {
        let validateTokenResponseHolder: any = response;
        if (validateTokenResponseHolder.status == this.statusConstant.statusSuccess) {
          this.loginToken = validateTokenResponseHolder.data.token;
          this.permissionsAssigned = validateTokenResponseHolder.data.permissions;
          this.databaseID = validateTokenResponseHolder.data.databaseID;
          this.organizationID = validateTokenResponseHolder.data.organizationID;
          this.folderAccess = validateTokenResponseHolder.data.folders;
          this.associatedAPIs = validateTokenResponseHolder.data.associatedAPIs;
          this.menuModules = validateTokenResponseHolder.data.menuModules;
          sessionStorage.setItem('profileImagePath', validateTokenResponseHolder.data.profileImagePath);
          sessionStorage.setItem('folderAccess', JSON.stringify(this.folderAccess));
          sessionStorage.setItem('associatedAPIs', JSON.stringify(this.associatedAPIs));
          sessionStorage.setItem('menuModules', JSON.stringify(this.menuModules));
          this._dataSharingService.SendMenu(true);
          validateTokenResponseHolder.data.officeList.forEach(oe => {
            if (oe.officeID == officeID) {
              this.myOfficeID = oe.officeID;
              oe.isMyoffice = true;
            }
            else {
              oe.isMyoffice = false;
            }
          });
          //
          sessionStorage.setItem('officeList', JSON.stringify(validateTokenResponseHolder.data.officeList));
          sessionStorage.setItem('userContactID', validateTokenResponseHolder.data.userContactID);
          sessionStorage.setItem('roleIDList', validateTokenResponseHolder.data.roleIDList);
          sessionStorage.setItem('roles', JSON.stringify(validateTokenResponseHolder.data.roles));
          // sessionStorage.setItem('email', this.LoggedInEmailId);
          this.decodedUserData = jwt_decode(this.loginToken);

          this.commonService.setLoggedInUserDetails(this.decodedUserData, this.loginToken,
            this.permissionsAssigned, this.menuModules, this.databaseID, this.organizationID);
          sessionStorage.removeItem("UserActivationEmail");
          sessionStorage.removeItem("UserActivationToken");
          sessionStorage.removeItem('alreadyLogin');
          sessionStorage.removeItem("LoginCountFailed");
          sessionStorage.removeItem("LoginTimer");

         // sessionStorage.removeItem("Paycheck");
         // sessionStorage.removeItem("PointClickCare");

          this.router.navigate(['/dashboard']);
         
          var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
          this.menuModulesList = menuModulesList.filter(x => x.mainModuleName != 'Admin' && x.mainModuleName != 'Settings');
        
          this.toastr.success("Office changed successfully.", '', {
            timeOut: 3000,
          });        
        }
        else {         
          this.toastr.error("Validation token is not correct.", '', {
            timeOut: 3000,
          });
        }
      }
    });
  }

  ngAfterViewInit() {
    this.signalRconnaction.connect();
    this.notificationSubscription = this.signalRconnaction.notification.subscribe(data => {
      if (data.targetUserId == this.currentUser.UID) {
        this.GetUnreadNotificationsCount();
        //this.getNotificationList(); 
      }
    });
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

 
  ngOnInit() {    
    this.getUserOffices();
    this.getOfficeDetail();
    this.modulename = sessionStorage.getItem('HeaderModuleName');
    this.clickFormEventsubscription = this._dataSharingService.getEmptyCurrentFormName().subscribe((val: any) => {
      this.currentFormName = '';
    });
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));

    var ChatList = [];
    var filterChat = [];
    ChatList = JSON.parse(sessionStorage.getItem("menuModules"));
    if (ChatList.length > 0) {
      filterChat = ChatList.filter(x => x.mainModuleName == 'Chat');
      if (filterChat.length > 0) {
        this.ShowChat = true;
      } else {
        this.ShowChat = false;
      }
    }

    this.clickEventsubscription = this._dataSharingService.getSelectedModuleName().subscribe((result) => {
      if (result == "") {
        if (result == "" && this.modulename == "") {
          this.modulename = "Unauthorised";
        }
      }
      else {
        this.modulename = sessionStorage.getItem('HeaderModuleName');
        this.edashboard = sessionStorage.getItem('edashboard');
        this.type = sessionStorage.getItem('type');

        // for Html Form
        if (this.type == "3") {
          this.projectName = "";
          this.currentFormName = sessionStorage.getItem('ProjectName');
        } else {
          this.currentFormName = "";
          this.projectName = sessionStorage.getItem('ProjectName');
        }
        this.cdr.detectChanges();
      }
    });



    // this.permissionAsssign = JSON.parse(sessionStorage.getItem("permissions"));  

    this.menuModulesList = menuModulesList.filter(x => x.mainModuleName != 'Admin' && x.mainModuleName != 'Settings');

    // var checkForm = this.permissionAsssign.filter((item) => item.permissionName == "Menu Forms");
    // if(checkForm.length >0){
    //  this.permissionAsssign.find((item) => item.permissionName == "Menu Forms").moduleRoute = 'Forms';
    // }

    // this.permissionAsssign =this.permissionAsssign.filter((x) => x.permissionName.toLowerCase() == 'menu core' 
    //                                                           || x.permissionName.toLowerCase() == 'menu task'
    //                                                           || x.permissionName.toLowerCase() == 'menu contact'
    //                                                           || x.permissionName.toLowerCase() == 'menu company'
    //                                                           || x.permissionName.toLowerCase() == 'menu forms');

    // this.folderListPermission = this.folderList.filter(o1 => this.permissionAsssign.some(o2 => o1.folderName.toLowerCase() === o2.moduleRoute.toLowerCase()));

    this.themes = this.theming.themes;

    this.notificationSubscription = this._dataSharingService.getNotificationRead().subscribe((result) => {
      if (result == true) {
        this.GetUnreadNotificationsCount();
        // this.getNotificationList(); 
      } else {
      }
    });

    this.clickEventsubscriptionUser = this._dataSharingService.getUpdateUserProfile().subscribe((result) => {
      if (result == true) {
        this.getUserDetailsManageUser();
      }
      else {
      }
    });

    this.getUserDetailsManageUser();
    this.GetUnreadNotificationsCount();
    //this.getNotificationList();   

    if (environment.production) {
      this.showLocalPanel = false;
    } else {
      this.showLocalPanel = true;
    }

    this.cdr.detectChanges();
  }

  getUserDetailsManageUser() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.formService.getUserDetailsManageUser(ReqModel).subscribe(response => {
      if (response) {
        this.userManageResponseHolder = response;
        if (this.userManageResponseHolder.status == this.statusConstant.statusSuccess) {
          this.userDetails = this.userManageResponseHolder.data;
          this.ImagePathURL = (this.userDetails.profileImageUrl == null || this.userDetails.profileImageUrl == undefined || this.userDetails.profileImageUrl == '') ? '' : this.userDetails.profileImageUrl;
          var firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.userDetails.firstName);
          var lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.userDetails.lastName);
          this.FullName = firstName + " " + lastName;
        }
        else {

        }
      }
    });
  }

  GetUnreadNotificationsCount() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeIDList: this.OfficeIDList,
      OfficeID: this.myOfficeID
    }
    this.formService.GetUnreadNotificationsCount(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.UnreadNotification = response.data;
          if (this.UnreadNotification > 100) {
            this.UnreadNotification = "100+";
          }
        }
        else {
        }
      }
      else {
      }
    });
  }

  ChangeFormName(val: any) {
    this.currentFormName = val;
    this._dataSharingService.SendCurrentFormName(val);
  }


  getNotificationList() {
    var ReqModel = {
      pageIndex: 0,
      pageSize: 10,
      searchKey: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeIDList: this.OfficeIDList,
      OfficeID: this.myOfficeID
    }
    this.formService.getNotificationList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.NotificationList = this.responseHolder.data.notificationDetailModelList.slice(0, 5);
          if (this.NotificationList.length > 0) {
            this.NotificationList = this.NotificationList.filter((v, i, a) => a.findIndex(t => (t.notificationMappingId === v.notificationMappingId)) === i)
          }
        }
        else {
          this.NotificationList = [];
        }
      }
      else {
        this.NotificationList = [];
      }
    });

  }

  ShowNotificationList() {
    this.getNotificationList();
  }

  Markallasread() {
    var ReqModel = {
      notificationMapIds: [],
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeIDList: this.OfficeIDList,
      OfficeID: this.myOfficeID
    }
    this.formService.MarkUnreadNotifications(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.GetUnreadNotificationsCount();
          this.getNotificationList();
        }
        else {
        }
      }
      else {
      }
    });

  }

  MarkPerticularRead(notification) {
    if (notification.isRead == false) {
      var notificationMapIds = [];
      notificationMapIds.push(notification.notificationMappingId);
      var ReqModel = {
        notificationMapIds: notificationMapIds,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        OfficeIDList: this.OfficeIDList,
        OfficeID: this.myOfficeID
      }
      this.formService.MarkUnreadNotifications(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
            this.GetUnreadNotificationsCount();
            this.getNotificationList();
          }
          else {
          }
        }
        else {
        }
      });
    }
    if (notification.moduleId == "1") {
      this.router.navigate(['/core/listing']);
    }
    if (notification.moduleId == "2") {
      this.router.navigate(['/company/listing']);
    }
    if (notification.moduleId == "3") {
      this.router.navigate(['/contact/listing']);
    }
    if (notification.moduleId == "4") {
      this._dataSharingService.SendCurrentFormContact(null);
      this.router.navigate(['/esignature']);
    }
    if (notification.moduleId == "7" || notification.moduleId == "8" || notification.moduleId == "9") {
      this._dataSharingService.SendCurrentFormContact(null);
      this.router.navigate(['/esignature/inbox']);
    }
  }

  addNew(folder) {
    this.Module = folder.orgModuleName;
    if (this.Module == "Task") {
      return;
    }
    else {
      this.showAddContact = !this.showAddContact;
    }
  }

  QuickForm() {
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");
    sessionStorage.setItem('type', '1');
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    this._dataSharingService.sendSelectedProjectName("");
    this.router.navigate(['/esignature/first']);
  }

  linkclick(link) {
    if (link == "Dashboard") {
      sessionStorage.setItem('DashboardRefresh', "true");
    }
    if (link == "My Profile") {
      this.router.navigate(['/users/profile']);
      this._dataSharingService.sendShowFormsSiderbar('My Profile');
    }
    sessionStorage.setItem('HeaderModuleName', link);
    this._dataSharingService.sendSelectedModuleName(link);
  }

  getClose(message) {
    this.showAddContact = message;
  }

  showChat(message: boolean) {
    this.openChat.emit(message)
  }

  openSidemenu() {
    document.body.classList.add('openmenu');
  }

  logOutUser() {
    sessionStorage.clear();
    this.router.navigate(['/auth/login']);

    //this.currentUser = {};
    // sessionStorage.removeItem("userToken");
    // sessionStorage.removeItem("permissions");
    // sessionStorage.removeItem("databaseId");
    // sessionStorage.removeItem("organizationID");
    // sessionStorage.removeItem("profileImagePath");
    // sessionStorage.removeItem("moduleName");
    // sessionStorage.removeItem("localFiltersContact");
    // sessionStorage.removeItem("localFiltersCompany");
    // sessionStorage.removeItem("localFilters");
    // sessionStorage.removeItem("folderAccess");
    // sessionStorage.removeItem("transactionID");
    // sessionStorage.removeItem("HeaderModuleName");
    // sessionStorage.removeItem("DashboardRefresh");
    // sessionStorage.removeItem("ProjectName");
    // sessionStorage.removeItem("projectID");
    // sessionStorage.removeItem("FolderOpenId");
    // sessionStorage.removeItem("type");  
    // sessionStorage.removeItem("ImportTemplateShow");


    // this.commonService.logoutUser();
  }

  getShortName(fullName) {
    var name = fullName;
    if (name != null || name != undefined) {
      return fullName.toUpperCase().split(' ').map(n => n[0]).join('');
    } else {
      return '';
    }
  }

  changeTheme(theme: string) {
    this.theming.theme.next(theme);
    this.currentTheme = theme;
  }

  showOtherLinks = false;

  userOtherLink() {
    this.showOtherLinks = !this.showOtherLinks
  }

  onChange(searchValue: string) {
    if (searchValue == "") {
      this._dataSharingService.sendProjectNameAlreadyExist(true);
      return;
    }
    var checkname = sessionStorage.getItem('ProjectName');
    if (checkname == searchValue) {
      this._dataSharingService.sendProjectNameAlreadyExist(false);
      return;
    }

    var type = Number(sessionStorage.getItem('type'));
    if (type == 1) {
      sessionStorage.setItem('ProjectName', searchValue);
      if (searchValue.trim() == "" || searchValue.trim() == undefined) {
        sessionStorage.setItem('ProjectName', searchValue.trim());
        return;
      }
      var ReqModel = {
        projectName: searchValue.trim(),
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        officeID:this.myOfficeID
      }
      this.formService.CheckProjectNames(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.data == false) {
            //  this.toastr.warning('Project name already exist.', '', {
            //   timeOut: 3000,
            // });
            this._dataSharingService.sendProjectNameAlreadyExist(true);
          } else {
            sessionStorage.setItem('ProjectName', searchValue);
            this._dataSharingService.sendProjectNameAlreadyExist(false);
          }
        } else {
        }
      });

    }


    if (type == 2) {
      sessionStorage.setItem('ProjectName', searchValue);
      if (searchValue.trim() == "" || searchValue.trim() == undefined) {
        sessionStorage.setItem('ProjectName', searchValue.trim());
        return;
      }
      var ReqModels = {
        formName: searchValue.trim(),
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        officeID:this.myOfficeID
      }
      this.formService.CheckProjectTemplateName(ReqModels).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.data == false) {
             this.toastr.warning(this.responseHolder.message, '', {
               timeOut: 3000,
            }); 
            // this.toastr.warning('Template name already exist.', '', {
            //   timeOut: 3000,
            // });
            this._dataSharingService.sendProjectNameAlreadyExist(true);
          } else {
            sessionStorage.setItem('ProjectName', searchValue);
            this._dataSharingService.sendProjectNameAlreadyExist(false);
          }
        } else {
        }
      });

    }


  }


  taskTemplateShow() {
    this.router.navigate(['/settings/managetasktemplates']);
  }

  FlowtricsAIChat(templateRef: TemplateRef<any>) {
    this.isHistoryToggleActivate = false;
    this.aiSearchHistory = [];
    this.isSearchActivated = false;
    this.searchText = '';
    this.dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-aichat',
    });
  }

  selectedSaveChatId: any;
  titleName: any;

  openSaveDialog(templateRef: TemplateRef<any>, chatId, question) {
    this.titleName = question;
    this.selectedSaveChatId = chatId;
    this.saveDialogRef = this.saveDialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  close() {
    this.dialogRef.close();
  }

  closeSaveDialog() {
    this.saveDialogRef.close();
  }

  copyResponse(tmpId) {
    const obj = this.aiData.find(m => m.tmpId == tmpId);
    const answer = obj && obj.answer;
    const selBox = document.createElement('textarea');
    selBox.value = answer;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.success("Response has been copied.", '', {
      timeOut: 3000,
    });
  }

  copyHistoryResponse(tmpId) {
    const obj = this.aiDataHistory.find(m => m.tmpId == tmpId);
    const answer = obj && obj.answer;
    const selBox = document.createElement('textarea');
    selBox.value = answer;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.success("Response has been copied.", '', {
      timeOut: 3000,
    });
  }

  saveResponse() {
    const obj = this.aiData.find(m => m.tmpId == this.selectedSaveChatId);
    var reqModel = {
      title: this.titleName,
      question: obj.question,
      answer: obj.answer,
      organizationID: this.organizationId,
      officeID: this.myOfficeID,
      createdBy: this.currentUser.UID
    }
    this._aiChatService.SaveFlowtricesAIMessage(reqModel).subscribe((response: any) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (response.data) {
            this.closeSaveDialog();
            this.toastr.success("Response has been saved succussfully.", '', {
              timeOut: 3000,
            });
          }
        }
      }
    });
  }

  addToCurrentChat(historyChat:any){  
    this.aiData=[];
    this.aiData.push(historyChat);
  }

  chatMsg: any = '';

  getAPIResponse() {
    if (this.chatMsg.trim().length > 0) {
      const chatValue = this.chatMsg.trim();
      this.chatMsg = '';
      const tmpIdValue = Math.random().toString();
      var reqModel = {
        tmpId: tmpIdValue,
        question: chatValue,
        answer: '',
        title: ''
      }
      this.aiData.push(reqModel);
      setTimeout(function () {
        const elem = document.getElementById('chatDiv1');
        elem.scrollTop = elem.scrollHeight;
      }, 500);
      this.loaderService.show();
      this.isLoading = true;
      this._aiChatService.GetResponseFromAI(reqModel).subscribe((response: any) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.aiData = this.aiData.filter(m => m.tmpId != tmpIdValue);
            this.aiData.push(response.data);
            setTimeout(function () {
              const elem = document.getElementById('chatDiv1');
              elem.scrollTop = elem.scrollHeight;
            }, 500);
          }
        }
        this.isLoading = false;
      });
    } else {
      this.toastr.warning("Please write your query first.", '', {
        timeOut: 3000,
      });
    }
  }

  chatHistoryMsg: string = 'Activate History Loading'
  pageSize: number = 20
  pageNumber: number = 0
  searchPageNumber: number = 1
  isHistoryToggleActivate: boolean = false;

  clickHistoryToggle(state) {
    this.existingSearchPageNumber = 0;
    this.existingHistoryPageNumber = 0;
    this.isHistoryToggleActivate = state;
    this.chatHistoryMsg = state ? 'De-Activate History Loading' : 'Activate History Loading';
    this.pageNumber = state && this.pageNumber == 0 ? 1 : this.pageNumber;
    if (state) {
      this.aiSearchHistory = [];
      this.aiDataHistory=[];
      this.isSearchActivated = false;
      this.searchText = '';
      this.searchPageNumber = 1;
      this.fetchHistory();
    }
    else
    { this.pageNumber=0;
      this.aiSearchHistory = [];
      this.aiDataHistory=[];
      this.aiData = this.aiData.filter(m => m.title !='')
    }
  }

  scrollHandler(event) {
    if (event.target.scrollTop == 0 && this.isHistoryToggleActivate) {
      this.fetchHistory();
    } else if (event.target.scrollTop == 0 && this.isSearchActivated) {
      this.fetchSearch();
    }
  }

  searchText: any;
  aiSearchHistory: any = [];
  isSearchActivated: boolean = false;

  search() {
    this.aiDataHistory = [];
    this.isHistoryToggleActivate = false;
    this.chatHistoryMsg = 'Activate History Loading';
    this.isSearchActivated = true;
    this.pageNumber = 0;
    this.fetchSearch();
  }

  existingSearchPageNumber: number = 0;

  Clearsearch(){
    if(this.searchText==''){
      this.aiDataHistory=[];
    }
  }

  fetchSearch() {
    if (this.isSearchActivated) {
      const reqModel = {
        organizationID: this.organizationId,
        officeID: this.myOfficeID,
        createdBy: this.currentUser.UID,
        Pagesize: this.pageSize,      
        PageNumber:1,
        searchText: this.searchText
      }     
        this.existingSearchPageNumber = this.searchPageNumber;
        this.isLoading = true;
        this.loaderService.show();
        this._aiChatService.GetFlowtricesAIMessage(reqModel).subscribe((response: any) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              if (response.data && response.data.length > 0) {
                this.searchPageNumber++;
                this.aiDataHistory=[];
                response.data
                  .forEach(element => {
                    this.aiDataHistory.splice(0, 0, {
                      title: element.title,
                      tmpId: element.tmpId,
                      question: element.question,
                      answer: element.answer
                    });
                  });
                setTimeout(function () {
                  const elem = document.getElementById('chatDiv1');
                  elem.scrollTop = 10;
                }, 100);
              }
            }
          }
          this.isLoading = false;
        });
      //}
    }
  }

  isLoading: boolean = false;
  existingHistoryPageNumber: number = 0;

  fetchHistory() {
    if (this.isHistoryToggleActivate) {
      const reqModel = {
        organizationID: this.organizationId,
        officeID: this.myOfficeID,
        createdBy: this.currentUser.UID,
        Pagesize: this.pageSize,
        PageNumber: this.pageNumber,
        searchText: ''
      }
      if (this.existingHistoryPageNumber == this.pageNumber) {
        this.toastr.warning("No More Data to load.", '', {
          timeOut: 3000,
        });
      }
      else {
        this.existingHistoryPageNumber = this.pageNumber;
        this.isLoading = true;
        this.loaderService.show();
        this._aiChatService.GetFlowtricesAIMessage(reqModel).subscribe((response: any) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              if (response.data && response.data.length > 0) {
                this.pageNumber++;
                response.data
                  .forEach(element => {
                    this.aiDataHistory.splice(0, 0, {
                      title: element.title,
                      tmpId: element.tmpId,
                      question: element.question,
                      answer: element.answer
                    });
                  });
                setTimeout(function () {
                  const elem = document.getElementById('chatDiv1');
                  elem.scrollTop = 10;
                }, 100);
              }
            }
          }
          this.isLoading = false;
        });
      }
    }
  }


  taskId:number=0;
  taskListID:number=0;
  moduleNames:string="Task";

  createNewTask() {
    this.taskId = 0;
    this.taskListID=0;
    this.showCreateTask = true;
  }


  getCloseCreateTask() {
    this.showCreateTask = false;
  }

  ResponseHolder:any;
  thirdPartyApplicationList:any=[]=[];

  getOfficeDetail() {   
    var ReqModel={
      officeID: Number(this.myOfficeID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
    }    
    this.formService.getOfficeDetail(ReqModel).subscribe((response) => {
     if (response != undefined) {
        this.ResponseHolder = response;       
        if(this.ResponseHolder.status == this.statusConst.statusSuccess) {          
          var office = this.ResponseHolder.data.office;
                 
          if(office!=null || office!=undefined){
            var logo = office.logo;
           
            if(logo!=null || logo!=undefined){
              this.officeLogo = logo;
            }else{
              this.officeLogo="";
            }                    
          } else{
            this.officeLogo="";
          }      
        }
      }
    });
  }

  getThirdPartyApplicationList() {  
    var ReqModel = {
      isOffice: true,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),  
    }
    this.formService.getThirdPartyApis(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.thirdPartyApplicationList = this.responseHolder.data; 
          if(this.thirdPartyApplicationList.length>0){
            var Paycheck=[];
            var PointClickCare=[];

            Paycheck = this.thirdPartyApplicationList.filter(x=>x.thirdPartyApiName.toLowerCase()=="Paychex".toLowerCase());
            PointClickCare = this.thirdPartyApplicationList.filter(x=>x.thirdPartyApiName.toLowerCase()=="PointClickCare".toLowerCase());

            sessionStorage.setItem('Paycheck','false');
            sessionStorage.setItem('PointClickCare','false');

            if(Paycheck.length>0){
              if(Paycheck[0].apiAuthDetail!=null){
                if(Paycheck[0].apiAuthDetail.isRequestclientAccessed==true){
                  sessionStorage.setItem('Paycheck','true');
                }                
              }             
            }

            if(PointClickCare.length>0){
              if(PointClickCare[0].apiAuthDetail!=null){
                if(PointClickCare[0].apiAuthDetail.isRequestclientAccessed==true){
                  sessionStorage.setItem('PointClickCare','true');
                }                
              }             
            }
          } 
        }
        else {         
          this.thirdPartyApplicationList=[];
        }
      }
      else {       
        this.thirdPartyApplicationList=[];
      }
    });
  } 

}
